import React from 'react';
import { useTranslation } from 'react-i18next';
import BentoGridPage from '../components/BentoGridPage/BentoGridPage';
import StarterBrandShowcase from '../components/starterBrandShowcase/StarterBrandShowcase';
import PageSEO from '../components/PageSEO';

const DesignPage = () => {
  const { t } = useTranslation('design');
  const fullDesc = t('header.description');
  const seoDesc = fullDesc.length > 160 ? fullDesc.slice(0, 157) + '…' : fullDesc;

  return (
    <main>
      <PageSEO
        title={`${t('header.titleBefore')} ${t('header.titleAccent')} — Web Design & UI/UX | PixelCraft`}
        description={seoDesc}
        path="/design"
      />
      <BentoGridPage />
      <StarterBrandShowcase />
    </main>
  );
}
export default DesignPage;